import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Authenticated from 'Components/Layouts/Authenticated';
import CmsElement from 'Components/Utilities/CmsElement';
import { Loading } from 'Components/Partials';
import { getRecordValue } from 'Services/CmsHelpers';
import { ModalTrigger } from 'Components/Modal';
import SpeakerModel from 'Components/Partials/Modals/SpeakerModel';
// ...existing code... (asset helper unused in this component)
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt";
import JoinUs from "Components/Partials/JoinUs";

export default class Speakers extends CmsElement {
    /**
     * @constructor
     */
    constructor() {
        super();
        this.state = {
            working: true,
            showContent: {}
        };
    }

    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'speakers';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    componentDidMount() {
        //AOS.init();
    }

    // ...existing code... (toggleContentVisibility removed - not used)

    /**
     * @method render
     * @return {*}
     */
    render() {
        const { working, records } = this.state;

        if (records && records.data) {
            // Initialize AOS for the first row with DOMContentLoaded
            AOS.init({
                duration: 1000,
                once: true,
                startEvent: 'DOMContentLoaded',
                easing: 'ease-in-out',
            });

            // Reinitialize AOS for the rest of the elements with scroll
            setTimeout(() => {
                AOS.init({
                    duration: 800,
                    once: true,
                    startEvent: 'scroll',
                    easing: 'ease-in-out',
                });
            }, 0);
        }

        return (
            <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                <div className="text-center bg-app-gray">
                    <div className="w-full mx-auto text-white bg-white">
                        <div className=" my-12 text-center text-2xl font-bold mx-auto text-app-blue">
                            {/*<img*/}
                            {/*    src={asset('images/agenda-date-banner.gif')}*/}
                            {/*    alt="Agenda Date Banner"*/}
                            {/*    className="w-full h-24 object-cover mt-2 p-4 max-w-4xl mx-auto"*/}
                            {/*/>*/}
                            Speakers
                        </div>

                        {working && <Loading />}

                        {!working && (
                            <div className="z-10 inline-flex justify-center items-center max-w-7xl w-full">
                                {records.data !== null &&
                                    (!records.data || records.data.length === 0) && (
                                        <p className="text-center">
                                            There are no Speakers. Please come back later
                                        </p>
                                    )}

                                {records.data && (
                                    <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 mt-8 mb-8 gap-8 items-stretch max-w-6xl w-full">
                                        {records.data.map(this.renderItem)}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <JoinUs/>

                {/*{!working && (*/}
                {/*    <video*/}
                {/*        src={asset('images/bupa-speakers-footer.mp4')}*/}
                {/*        alt="video"*/}
                {/*        className="m-auto min-w-0 h-full w-full hidden lg:block"*/}
                {/*        controls={false}*/}
                {/*        autoPlay*/}
                {/*        muted={true}*/}
                {/*        controlsList="nodownload nofullscreen noremoteplayback"*/}
                {/*        loop*/}
                {/*        playsInline={true}*/}
                {/*    />*/}
                {/*)}*/}
            </Authenticated>
        );
    }

    /**
     * @method renderItem
     * @param {object} item
     * @param {string} key
     * @return {JSX.Element}
     */
    renderItem = (item, key) => {
        let thumbnail = getRecordValue(item, 'thumbnail');
        let title = getRecordValue(item, 'title');
        let company_name = getRecordValue(item, 'company_name');
        let company_thumbnail = getRecordValue(item, 'company_thumbnail');
        let job_title = getRecordValue(item, 'job_title');
        let spotify = getRecordValue(item, 'spotify');
        let linkedin = getRecordValue(item, 'linkedin');

        return (
            <div
                key={key}
                className="flex flex-row h-56 rounded-lg overflow-hidden shadow-sm"
                data-aos="fade-up"
                data-aos-delay={key * 100}
            >
                {/* Left: image */}
                <div className="w-[37%] relative overflow-hidden rounded-l-lg bg-gray-100">
                    {thumbnail && thumbnail.url ? (
                        <img
                            src={thumbnail.url}
                            alt={title ?? ''}
                            className="h-full w-full object-cover"
                        />
                    ) : (
                        <div className="h-full w-full bg-gray-200" />
                    )}
                </div>

                {/* Right: content (light teal) */}
                <div className="w-[63%] p-6 lg:p-8 bg-[#9EF0F0] text-[#004144] flex flex-col justify-between relative overflow-hidden">
                    {/* Company logo (bottom-right), sized down so it never overlaps the text */}
                    {company_thumbnail && company_thumbnail.url && (
                        <img
                            src={company_thumbnail.url}
                            alt={company_name ?? ''}
                            className="absolute right-4 bottom-4 w-16 h-16 lg:w-24 lg:h-24 object-contain pointer-events-none"
                        />
                    )}

                    {/* Text column constrained to ~60% so long titles wrap before the logo */}
                    <div className="relative z-10 text-left max-w-[60%]">
                        {title && (
                            <div className="text-lg lg:text-xl font-extrabold leading-tight">
                                {title}
                            </div>
                        )}
                        {(job_title || company_name) && (
                            <div className="mt-2 text-xs leading-tight">
                                {job_title && <div>{job_title}</div>}
                                {company_name && <div>{company_name}</div>}
                            </div>
                        )}
                    </div>

                    <div className="relative z-10 flex flex-wrap items-center gap-3 mt-4 max-w-[60%]">
                        {linkedin && (
                            <a
                                href={linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block bg-[#004144] text-[#9EF0F0] rounded-full px-5 py-1.5 text-sm font-medium"
                            >
                                LinkedIn
                            </a>
                        )}

                        <ModalTrigger
                            component={SpeakerModel}
                            props={{ speaker: item }}
                        >
                            <button className="text-[#004144] border-b-2 border-[#004144] pb-1 font-medium text-xs">
                                View full profile
                            </button>
                        </ModalTrigger>

                        {spotify && (
                            <a
                                href={spotify}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#004144] flex items-center text-sm ml-auto"
                            >
                                Spotify <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-1.5 text-xs" />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        );
    };
}
